import React, { useEffect, useState } from 'react';
import EmailsInputFromListView from '../view/EmailsInputFromListView';
import sortInfoNames from '../../utils/sortInfoNames';
import { useFetchAllWithCallbacks } from '../../hooks/useFetchWithCallbacks';

const EmailsInputFromListEngine = ({
  defaultRecipient,
  defaultToUserIds,
  onChange: givenOnChange,
  users: givenUsers,
  formId,
  submissionId
}) => {
  let defaultRecipientSelections = [];
  const [loadedStakeholders, setLoadedStakeholders] = useState(false);
  const [viewProps, setViewProps] = useState({});
  const fetchAll = useFetchAllWithCallbacks();

  if (defaultToUserIds) {
    defaultRecipientSelections = defaultToUserIds.map(oneUserId => {
      let matchingUser = givenUsers.find(one => one.id === oneUserId);
      if (matchingUser) {
        return {
          label: `${matchingUser.info.email}`,
          value: matchingUser.id          
        };
      }
      return null;
    });
  } else if (defaultRecipient) {
    defaultRecipientSelections = [
      {
        label: `${defaultRecipient.info.email}`,
        value: defaultRecipient.id
      }
    ];
  }

  const [value, setValue] = useState(defaultRecipientSelections);

  useEffect(() => {
    if (!loadedStakeholders) {
      fetchAll(`/forms/v1/forms/${formId}/submissions/${submissionId}/stakeholders`).then(res => {
        setLoadedStakeholders(true);
        let users = [...res.results];
        users = users.sort(sortInfoNames);
        setViewProps({
          options: users.map(one => {return {label: `${one.info.firstName} ${one.info.lastName}<${one.info.email}>`, value: one.id};}),
        });
      });
    }
  }, [loadedStakeholders]);

  const onChange = v => {
    let newValue = v ? v : [];
    setValue(newValue);
    givenOnChange(newValue.map(one => one.value));
  };

  if (!loadedStakeholders) {
    return '';
  }
  return (
    <EmailsInputFromListView
      onChange={onChange}
      value={value}
      {...viewProps}
    />
  );
};

export default EmailsInputFromListEngine;
